import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelCaseToSentence'
})
export class CamelCaseToSentencePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }

    // Insert spaces before each uppercase letter
    const stringWithSpaces = value.replace(/([A-Z])/g, ' $1');

    // Capitalize the first letter and convert the rest to lowercase
    const sentenceCase = stringWithSpaces.charAt(0).toUpperCase() + stringWithSpaces.slice(1).toLowerCase();

    return sentenceCase.trim();
  }
}